<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useStatisticsWizardStore } from '../../stores';
import { WizardOverviewParcelCard } from '@shared';
import { StatisticsKind } from '../../enums';
import { useOverviewStep } from '../../composables';

const statisticsWizardStore = useStatisticsWizardStore();
const { statisticsData, isStatisticsSaveValid, isUiDisabled } = storeToRefs(statisticsWizardStore);

const { getOwnMetadata } = useOverviewStep(statisticsData);
</script>

<template>
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-0">
      <v-card
        variant="flat"
        :title="$t('plan.wizard.step.overview')" />
    </div>
    <div class="flex-grow-1 position-relative mt-4 mb-4">
      <div
        class="h-100 position-absolute d-flex flex-column align-content-lg-space-between overflow-x-hidden gap-1 pl-4 pr-4 pb-4 pt-1"
        style="top: 0; left: 0; right: 0; bottom: 0; overflow-y: scroll">
        <transition-group name="application-data-items">
          <wizard-overview-parcel-card
            v-for="parcel in statisticsData.parcels"
            :key="parcel.id"
            :parcel="parcel"
            :module-class-name="'statistics'">
            <template #item>
              <div class="d-flex flex-wrap ga-2 mt-2">
                <v-chip
                  v-for="(source, index) in getOwnMetadata(parcel.id)"
                  :key="index"
                  size="small">
                  <p v-if="statisticsData.kind !== StatisticsKind.SOIL_TEMPERATURE">
                    {{ $t(`statistics.wizard.label.${source.statisticsSource}`) }}:&nbsp;
                  </p>
                  <p>{{ source.label }}</p>
                </v-chip>
              </div>
            </template>
          </wizard-overview-parcel-card>
        </transition-group>
      </div>
    </div>
    <div class="flex-grow-0 pa-4 text-center">
      <v-text-field
        v-model="statisticsData.name"
        :label="$t('statistics.wizard.label.statisticsName')"
        :disabled="isUiDisabled"
        variant="outlined"
        density="compact"
        :hide-details="true"
        @update:model-value="statisticsWizardStore.validateStatisticsSave"
        @blur="statisticsWizardStore.validateStatisticsSave" />
      <v-btn
        color="primary"
        class="mt-4"
        :disabled="isUiDisabled || !isStatisticsSaveValid"
        @click.prevent.stop="statisticsWizardStore.saveStatistics">
        {{ $t('statistics.wizard.label.saveStatistics') }}
      </v-btn>
    </div>
  </div>
</template>
